/**
 * Mobile Product Slider
 * Initializes Swiper for mobile product images with pagination dots
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  function initMobileProductSlider() {
    const sliderElements = document.querySelectorAll('.mobile-product-slider');
    
    if (!sliderElements.length) return;
    
    // Check if Swiper is loaded
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded. Loading from CDN...');
      loadSwiperFromCDN();
      return;
    }
    
    sliderElements.forEach(initSlider);
  }
  
  function loadSwiperFromCDN() {
    // Load Swiper CSS
    const swiperCSS = document.createElement('link');
    swiperCSS.rel = 'stylesheet';
    swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(swiperCSS);
    
    // Load Swiper JS
    const swiperJS = document.createElement('script');
    swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    swiperJS.onload = function() {
      initMobileProductSlider();
    };
    document.head.appendChild(swiperJS);
  }
  
  function initSlider(sliderElement) {
    const productId = sliderElement.getAttribute('data-product-id');
    const hasPagination = sliderElement.getAttribute('data-show-pagination') === 'true';
    
    // Swiper configuration
    const config = {
      // Core settings
      loop: true,
      speed: 600,
      effect: 'slide',
      
      // Autoplay
      autoplay: {
        delay: 3500,
        disableOnInteraction: false
      },
      
      // Pagination (dots)
      pagination: {
        el: sliderElement.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets'
      },
      
      // Touch settings
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      
      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      
      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      }
    };
    
    // Initialize Swiper
    const swiper = new Swiper(sliderElement, config);
    
    // Store swiper instance
    sliderElement.swiperInstance = swiper;
    
    // Add touch support class
    if ('ontouchstart' in window) {
      sliderElement.classList.add('touch-enabled');
    }
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileProductSlider);
  } else {
    initMobileProductSlider();
  }
  
  // Re-initialize on Shopify section re-render
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      setTimeout(initMobileProductSlider, 100);
    });
  }
  
})();
